// season.ts
// T-104 (v1.8.25, Kundin-Mail 23.09.2026 13:25): Floßfahrten finden nur in der Saison Mai bis Oktober statt
// ("außerhalb dieser Monate KEINE Floßfahrten"). Die Monatsnavigation der Kalender (Online-Buchung,
// Kundenkonto, Verwaltung, Buchungsablauf der Verwaltung) springt deshalb von Oktober direkt auf Mai des
// Folgejahres und von Mai zurück auf Oktober des Vorjahres. Saison bestätigt durch die Kundin 24.09.2026
// (01.05. bis 31.10.). Grenzen hier zentral; eine spätere Systemeinstellung kann sie ersetzen.

/** Erster Saisonmonat (1 = Januar). */
export const SEASON_START_MONTH = 5;
/** Letzter Saisonmonat (1 = Januar). */
export const SEASON_END_MONTH = 10;

const monthOf = (d: Date): number => d.getMonth() + 1;

/** Liegt der Monat des Datums in der Saison (Mai bis Oktober)? */
export const isSeasonMonth = (d: Date): boolean =>
  monthOf(d) >= SEASON_START_MONTH && monthOf(d) <= SEASON_END_MONTH;

/** Erster Tag des Monats (lokale Zeit). */
const firstOfMonth = (year: number, month1: number): Date => new Date(year, month1 - 1, 1);

/**
 * Nächster Saisonmonat nach dem Monat von `current`: innerhalb der Saison der Folgemonat, ab Oktober
 * (oder aus dem Winter heraus) der Mai des Folgejahres bzw. des laufenden Jahres (Januar bis April).
 */
export const nextSeasonMonth = (current: Date): Date => {
  const m = monthOf(current);
  const y = current.getFullYear();
  if (m >= SEASON_START_MONTH && m < SEASON_END_MONTH) return firstOfMonth(y, m + 1);
  if (m < SEASON_START_MONTH) return firstOfMonth(y, SEASON_START_MONTH);
  return firstOfMonth(y + 1, SEASON_START_MONTH); // Oktober bis Dezember
};

/**
 * Vorheriger Saisonmonat vor dem Monat von `current`: innerhalb der Saison der Vormonat, ab Mai
 * (oder aus dem Winter heraus) der Oktober des Vorjahres bzw. des laufenden Jahres (November, Dezember).
 */
export const prevSeasonMonth = (current: Date): Date => {
  const m = monthOf(current);
  const y = current.getFullYear();
  if (m > SEASON_START_MONTH && m <= SEASON_END_MONTH) return firstOfMonth(y, m - 1);
  if (m > SEASON_END_MONTH) return firstOfMonth(y, SEASON_END_MONTH);
  return firstOfMonth(y - 1, SEASON_END_MONTH); // Januar bis Mai
};

/**
 * Startmonat für einen Kalender: der aktuelle Monat, wenn er in der Saison liegt, sonst der nächste Mai
 * (November/Dezember: Folgejahr, Januar bis April: laufendes Jahr).
 */
export const initialSeasonMonth = (today: Date = new Date()): Date => {
  if (isSeasonMonth(today)) return firstOfMonth(today.getFullYear(), monthOf(today));
  return nextSeasonMonth(today);
};

/** Kurzer Hinweistext für Kalenderköpfe. */
export const SEASON_HINT = 'Saison Mai bis Oktober';
